// extracted by mini-css-extract-plugin
export default {"loadingRout":"context_loadingRout__TefB1"};